import { useSearchParams } from "react-router-dom";
import PrivatePostPage from "../pages/PrivatePostPage";
import ContentGallery from "./ContentGallery";
import DashboardLayout from "./DashboardLayout";

export default function DraftsRoute() {
  const [params] = useSearchParams();
  const postId = params.get("viewPost");
  return postId ? (
    <PrivatePostPage postId={postId} />
  ) : (
    <DashboardLayout>
      <ContentGallery />
    </DashboardLayout>
  );
}
